import React from 'react'
import { ImageContainer, BackgroundImage, ContentOverlay, Title, SubTitle } from '../styles/BackgroundImageStyle'
import {
  TeamContainer,
  TeamHeader,
  TeamWrapper,
  TeamCard,
  TeamImage,
  TeamCardContent,
  TeamName,
  TeamRole,
} from '../styles/OurTeamStyles'

const properties = [
  {
    id: 1,
    image: "/assets/images/team1.jpg",
    name: "Sophia Matthew",
    role: "CEO and Luxery Realtor",
  },
  {
    id: 2,
    image: "/assets/images/team2.jpg",
    name: "James Anderson",
    role: "Senior Property Consultant",
  },
  {
    id: 3,
    image: "/assets/images/team3.jpg",
    name: "Emma Johnson",
    role: "Marketing Specialist",
  },
  {
    id: 4,
    image: "/assets/images/team4.jpg",
    name: "Liam Brown",
    role: "Lead Developer",
  },
  {
    id: 5,
    image: "/assets/images/team5.jpg",
    name: "Olivia Davis",
    role: "Customer Relationship Manager",
  },
  {
    id: 6,
    image: "/assets/images/team6.jpg",
    name: "Noah Wilson",
    role: "Investment Advisor",
  },
  {
    id: 7,
    image: "/assets/images/team7.jpg",
    name: "Ava Martinez",
    role: "Property Manager",
  },
  {
    id: 8,
    image: "/assets/images/team8.jpg",
    name: "Ethan Moore",
    role: "Real Estate Agent",
  }

]


const OurTeam = () => {
  return (
    <div>
      <ImageContainer>
        {/* Background Image */}
        <BackgroundImage
          src="/assets/images/team.jpg"
          alt="background-image"
        />
        {/* Content Overlay */}
        <ContentOverlay>
          <Title>Meet Our Team</Title>
          <SubTitle>Get to know our talented team.</SubTitle>
        </ContentOverlay>
      </ImageContainer>


      <TeamContainer>
        <TeamHeader>Our Team</TeamHeader>
        <TeamWrapper>
          {properties.map((property) => (
            <TeamCard key={property.id}>
              
                <TeamImage src={property.image} alt={property.role} />
              
              <TeamCardContent>
                <a href="#home" className='no-underline'>
                  <TeamName>{property.name}</TeamName>
                </a>
                <TeamRole>{property.role}</TeamRole>
              </TeamCardContent>
            </TeamCard>
          ))}
        </TeamWrapper>
      </TeamContainer>
    </div>
  )
}

export default OurTeam